type LogoSize = {
  width?: number;
  height?: number;
  naturalWidth: number;
  naturalHeight: number;
};

// Partner lockups range from wide (UMB, 98x25) to nearly square (Armstrong,
// 71x74), so a call site gives whichever dimension its layout constrains and the
// other follows from the logo's own aspect ratio.
//
// Deliberately dependency-free: the logo components import it, and they are
// themselves read by the partner bank registry.
export const resolveLogoSize = ({ width, height, naturalWidth, naturalHeight }: LogoSize) => {
  const ratio = naturalWidth / naturalHeight;

  if (width !== undefined && height !== undefined) return { width, height };
  if (width !== undefined) return { width, height: width / ratio };
  if (height !== undefined) return { width: height * ratio, height };

  return { width: naturalWidth, height: naturalHeight };
};
